import { Fragment } from 'react'

import { m } from 'framer-motion'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

import OnboardingImageScreen2 from '@/assets/images/clashroyale/onboarding-image-screen-4.png'

import { animationBase } from '../../../constants'

import styles from './styles.module.scss'

export const Screen4 = () => {
  const t = useTranslations()

  return (
    <Fragment>
      <m.h1
        {...animationBase}
        key="cr-screen-4-title"
        transition={{ duration: 0.2, delay: 0.3, ease: 'easeInOut' }}
        className={styles.Title}
      >
        {t('stamps_info_gold_pass_purchases').toUpperCase()}
      </m.h1>
      <m.div
        {...animationBase}
        key="cr-screen-4-image"
        transition={{ duration: 0.2, delay: 0.2, ease: 'easeInOut' }}
        className={styles.ItemArea}
      >
        <Image src={OnboardingImageScreen2} alt="" width={210} />
      </m.div>
      <m.div
        {...animationBase}
        key="cr-screen-4-footer"
        transition={{ duration: 0.2, delay: 0.1, ease: 'easeInOut' }}
        className={styles.BottomText}
      >
        <p>{t('stamps_info_gold_pass_stamp_card')}</p>
      </m.div>
    </Fragment>
  )
}
